import React, { useState } from "react";
import classNames from "classnames";
import { ReactComponent as DropdownSVG } from "go-core/images/svg/dropdown.svg";
import { ImportOverviewConfig } from "../../../../services/types";

interface Props {
	response: Record<string, any>[];
	importOverviewConfig: ImportOverviewConfig;
}

const PreviewItemsTable = ({ response, importOverviewConfig }: Props) => {
	const {
		previewItemsColumns,
		previewItemsResponseKey,
		previewNestedItemsResponseKey,
		previewNestedItemsRender,
		previewItemsKeyName,
	} = importOverviewConfig;
	const [expandedRows, setExpandedRows] = useState<number[]>([]);

	const toggleExpandRow = (rowIndex: number) => {
		if (expandedRows.includes(rowIndex)) {
			const rowIndexExpandedRowsIndex = expandedRows.indexOf(rowIndex);
			const newExpandedRows = [...expandedRows];
			newExpandedRows.splice(rowIndexExpandedRowsIndex, 1);
			setExpandedRows(newExpandedRows);
		} else {
			setExpandedRows((prevExpandedRows) => [...prevExpandedRows, rowIndex]);
		}
	};

	return (
		<div className="table-responsive mb-5">
			<table className="table table-preview items-with-errors-preview">
				<thead>
					<tr>
						{previewItemsColumns.map(({ id, name }, index) => {
							return (
								<th className={index === 0 ? "ps-3" : ""} key={id}>
									{name}
								</th>
							);
						})}
					</tr>
				</thead>
				<tbody>
					{response.map((responseItem, rowIndex) => {
						const responseDataItem = responseItem[previewItemsResponseKey];
						const responseDataNestedItems: Record<string, any>[] =
							responseDataItem[previewNestedItemsResponseKey];
						const isRowExpanded = expandedRows.includes(rowIndex);

						return (
							<React.Fragment key={responseDataItem[previewItemsKeyName]}>
								<tr>
									{previewItemsColumns.map(({ id, render }, index) => {
										const currentCellData = responseDataItem[id];

										return index === 0 ? (
											<td
												key={id}
												className="d-flex align-items-center text-break text-wrap expand-item-row"
											>
												<DropdownSVG
													className={classNames("dropdown-svg", {
														"dropdown-svg--expanded": isRowExpanded,
													})}
													onClick={() => toggleExpandRow(rowIndex)}
												/>
												{render?.(responseDataItem) ?? currentCellData}
											</td>
										) : (
											<td key={id} className="text-break text-wrap">
												{render?.(responseDataItem) ?? currentCellData}
											</td>
										);
									})}
								</tr>
								{isRowExpanded &&
									responseDataNestedItems &&
									responseDataNestedItems.map((nestedItem) => {
										return (
											<tr key={nestedItem.id}>
												<td colSpan={previewItemsColumns.length}>
													{previewNestedItemsRender(nestedItem)}
												</td>
											</tr>
										);
									})}
							</React.Fragment>
						);
					})}
				</tbody>
			</table>
		</div>
	);
};

export default PreviewItemsTable;
